import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";

export const getCategoryAttributes = async (entId, catId) => {
  try {
    const url = `${apiRoutes.falabella.categories}/catAtt/${entId}/${catId}`;
    return await api.get(url);
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

export const publishToFalabella = async (
  enterpriseId,
  paramsToSend,
  category,
  publishGroup
) => {
  try {
    // ✅ VALIDACIONES DE ENTRADA
    if (!enterpriseId) {
      throw new Error('enterpriseId es requerido');
    }
    if (!paramsToSend || paramsToSend.length === 0) {
      throw new Error('paramsToSend no puede estar vacío');
    }
    if (!category) {
      throw new Error('category es requerida');
    }

    const url = `${apiRoutes.falabella.products}/publish-products`;
    const response = await api.post(url, {
      entId: enterpriseId,
      products: paramsToSend,
      category,
      publishGroup,
    });
    
    // ✅ VALIDACIÓN DE RESPUESTA
    if (!response?.data?.data) {
      throw new Error('Respuesta inválida del servidor');
    }
    
    return response;
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

/**
 * Obtiene las marcas disponibles de Falabella
 * @param {string} enterpriseId - ID de la empresa
 * @returns {Promise} Respuesta con las marcas
 */
export const getFalabellaBrands = async (enterpriseId) => {
  try {
    const url = `${apiRoutes.falabella.products}/brands/${enterpriseId}`;
    return await api.get(url);
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

export const downloadFalabellaBrands = async (enterpriseId) => {
  try {
    const url = `${apiRoutes.falabella.categories}/Downbrands/${enterpriseId}`;
    return await api.get(url);
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

export const donwloadFalabellaCategories = async (enterpriseId) => {
  try {
    const url = `${apiRoutes.falabella.categories}/DowncatTree/${enterpriseId}`;
    return await api.get(url);
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

export const getReportFalabella = async (enterpriseId, fileType) => {
  try {
    const url = `${apiRoutes.falabella.products}/${enterpriseId}/report/${fileType}`;
    return await api.get(url);
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};